<template>
  <v-snackbar
    v-if="!!getSnackbarToDisplay"
    :key="getSnackbarToDisplay.id"
    :color="getSnackbarToDisplay.color"
    :model-value="true"
    location="bottom right"
    :timeout="getSnackbarToDisplay.timeout"
    max-width="400px"
    width="400px"
    min-height="68"
    transition="scroll-x-reverse-transition"
    data-cy="kp-snackbar-container"
    @update:model-value="snackbarCallback"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      data-cy="kp-snackbar__content"
      class="text-body-small"
      :class="{ 'cursor-pointer': hasCallback() }"
      @click="clickCallback"
      v-html="snackBarkContent"
    />
    <template
      #actions
    >
      <v-btn
        v-if="!!getSnackbarToDisplay.icon"
        data-cy="kp-snackbar__close"
        :icon="getSnackbarToDisplay.icon"
        @click="localDeleteSnackbar"
      />
    </template>
  </v-snackbar>
</template>

<script>
import { mapMutations } from '~/store';
import useSnackbarQueue from '~/composables/useSnackbarQueue';

export default {
  name: 'KpSnackbarQueue',
  setup() {
    const { getSnackbarToDisplay, deleteSnackbar } = useSnackbarQueue();
    return { getSnackbarToDisplay, deleteSnackbar };
  },
  computed: {
    /**
     * Content to display in the snackbar
     */
    snackBarkContent() {
      if (!this.getSnackbarToDisplay) return '';
      if (this.getSnackbarToDisplay.translate) return this.$t(this.getSnackbarToDisplay.content);

      return this.getSnackbarToDisplay.content;
    },
  },
  methods: {
    ...mapMutations('changeovers', ['commitIsModalRunningChangeoverOpen']),
    /**
     * Deletes the snackbar that is being displayed
     */
    localDeleteSnackbar() {
      if (this.getSnackbarToDisplay) this.deleteSnackbar(this.getSnackbarToDisplay.id);
    },
    /**
     * Callback when the v-snackbar decides to close/open
     */
    snackbarCallback(payload) {
      if (!payload) this.localDeleteSnackbar();
    },
    /**
     * Checks if the snackbar has a callback
     * @returns {boolean}
     */
    hasCallback() {
      return this.getSnackbarToDisplay && this.getSnackbarToDisplay.callback;
    },
    /**
     * Action on snackbar click
     */
    clickCallback() {
      if (this.hasCallback()) {
        if (this.getSnackbarToDisplay.callback === 'openChangeoverClosure') {
          this.commitIsModalRunningChangeoverOpen(true);
        } else {
          // Simply run the function
          this.getSnackbarToDisplay.callback();
        }
      }
    },
  },
};
</script>
